import React from "react";
import { AddImageIcon, BackIcon, CancelIcon, CloseIcon } from "../../assets/Icons";
import Groups from "../Groups";
import PortalV2CreatableSelect from "../common/PortalV2CreatableSelect";
import PortalV2Select from "../common/PortalV2Select";
import { MachineTyepeOptions } from "../common/MachineTypeSelect";

const EntityFormV2View = ({
  config,
  navigate,
  getRootProps,
  getInputProps,
  uploadedIcon,
  machineImage,
  handleCancelUpload,
  machineName,
  machineId,
  serialNumber,
  error,
  handleChange,
  setMachineName,
  setMachineId,
  setSerialNumber,
  setMake,
  setLocation,
  setMachineType,
  make,
  location,
  machineType,
  makes,
  locations,
  categories,
  handleSelectChange,
  selectedUsers,
  userList,
  nameSearch,
  setNameSearch,
  showList,
  setShowList,
  handleClickSelectUSer,
  handleClickCancelUSer,
  search,
  setSearch,
  groups,
  selectedGroups,
  setSelectedGroups,
  setParentGroupId,
  ParentGroupId,
  processing,
  handleSave,
  resetForm,
}) => {
  const getInitials = (name = "") => {
    const parts = name.split(" ");
    if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    return parts[0]?.[0]?.toUpperCase() || "";
  };

  return (
    <div className="portal-v2-form">
      <button type="button" className="portal-v2-form__back" onClick={() => navigate(-1)}>
        <BackIcon />
        Back
      </button>

      <div className="portal-v2-form__head">
        <h1>{config.pageTitle}</h1>
        <p>{config.pageSubtitle}</p>
      </div>

      <div className="portal-v2-form__card">
        <div className="portal-v2-form__grid">
          <div className="portal-v2-form__col">
            <div className="portal-v2-form__upload">
              <div {...getRootProps()} className="portal-v2-form__dropzone">
                <input {...getInputProps()} />
                {uploadedIcon || machineImage ? (
                  <div className="portal-v2-form__upload-preview">
                    <img src={uploadedIcon || machineImage} alt="Uploaded" />
                    <button type="button" onClick={handleCancelUpload} className="portal-v2-form__upload-remove">
                      <CancelIcon />
                    </button>
                  </div>
                ) : (
                  <div className="portal-v2-form__upload-placeholder">
                    <AddImageIcon />
                    <span>Upload logo</span>
                  </div>
                )}
              </div>
              <div className="portal-v2-form__upload-meta">
                <strong>Logo</strong>
                <small>Recommended format: PNG</small>
              </div>
            </div>

            <label className="portal-v2-form__field">
              <span>
                {config.nameLabel} <em>*</em>
              </span>
              <input
                autoComplete="off"
                name="machineName"
                className="portal-v2-form__input"
                type="text"
                value={machineName}
                onChange={handleChange(setMachineName)}
              />
              {error.machineName && <p className="portal-v2-form__error">{error.machineName}</p>}
            </label>

            <label className="portal-v2-form__field">
              <span>
                {config.idLabel} <em>*</em>
              </span>
              <input
                autoComplete="off"
                name="machineId"
                className="portal-v2-form__input"
                type="text"
                value={machineId}
                onChange={handleChange(setMachineId)}
              />
              {error.machineId && <p className="portal-v2-form__error">{error.machineId}</p>}
            </label>
          </div>

          <div className="portal-v2-form__col">
            <label className="portal-v2-form__field">
              <span>Serial Number</span>
              <input
                autoComplete="off"
                name="serialNumber"
                className="portal-v2-form__input"
                type="text"
                value={serialNumber}
                onChange={handleChange(setSerialNumber)}
              />
              {error.serialNumber && <p className="portal-v2-form__error">{error.serialNumber}</p>}
            </label>

            <div className="portal-v2-form__field">
              <PortalV2CreatableSelect
                option={makes.map((e) => ({ value: e.name, label: e.name, id: e.id }))}
                handleSelect={handleSelectChange(setMake)}
                categoryId={categories.make}
                label="Select Make"
                showImportant={config.makeRequired}
                value={make}
                placeholder="Select make"
              />
              {error.make && <p className="portal-v2-form__error">{error.make}</p>}
            </div>

            {config.showLocation && (
              <div className="portal-v2-form__field">
                <PortalV2CreatableSelect
                  option={locations.map((e) => ({ value: e.name, label: e.name, id: e.id }))}
                  handleSelect={handleSelectChange(setLocation)}
                  categoryId={categories.location}
                  label="Select Location"
                  showImportant={false}
                  value={location}
                  placeholder="Select location"
                />
                {error.location && <p className="portal-v2-form__error">{error.location}</p>}
              </div>
            )}

            {config.showMachineType && (
              <div className="portal-v2-form__field">
                <PortalV2Select
                  layout="field"
                  label="Machine Type"
                  value={machineType}
                  options={MachineTyepeOptions}
                  onChange={setMachineType}
                  placeholder="Select machine type"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="portal-v2-form__card portal-v2-form__section">
        <h2>Users to be notified</h2>
        <div className="portal-v2-form__users">
          <div className="portal-v2-form__users-chips">
            {selectedUsers?.map((user, index) => (
              <div key={user.uuid || index} className="portal-v2-form__user-chip">
                <span className="portal-v2-form__user-avatar">
                  {user.avatar ? (
                    <img src={user.avatar} referrerPolicy="no-referrer" alt="" />
                  ) : (
                    <span className="portal-v2-form__user-initials">{getInitials(user.name)}</span>
                  )}
                </span>
                <div className="portal-v2-form__user-meta">
                  <strong>{user.name}</strong>
                  <small>{user.email || user.uid}</small>
                </div>
                <button
                  type="button"
                  onClick={() => handleClickCancelUSer(user, index)}
                  className="portal-v2-form__user-remove"
                >
                  <CloseIcon />
                </button>
              </div>
            ))}
          </div>
          <div className="portal-v2-form__user-search">
            <input
              type="text"
              placeholder="Add users..."
              className="portal-v2-form__input"
              value={nameSearch}
              onChange={(e) => setNameSearch(e.target.value)}
              onFocus={() => setShowList(true)}
              onBlur={() => setTimeout(() => setShowList(false), 200)}
            />
            {showList && (
              <div
                className="portal-v2-form__user-dropdown"
                onMouseDown={(e) => e.preventDefault()}
                onWheel={(e) => e.stopPropagation()}
              >
                {userList.map((user, index) => {
                  if (nameSearch && !user.name.toLowerCase().includes(nameSearch.toLowerCase())) return null;
                  return (
                    <button
                      type="button"
                      key={user.uuid || index}
                      className="portal-v2-form__user-option"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleClickSelectUSer(user, index);
                      }}
                    >
                      <span className="portal-v2-form__user-avatar">
                        {user.avatar ? (
                          <img src={user.avatar} alt="" referrerPolicy="no-referrer" />
                        ) : (
                          <span className="portal-v2-form__user-initials">{getInitials(user.name)}</span>
                        )}
                      </span>
                      <span className="portal-v2-form__user-option-name">{user.name}</span>
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="portal-v2-form__card portal-v2-form__section portal-v2-form__groups-wrap">
        <Groups
          setSearch={setSearch}
          search={search}
          groups={groups}
          selectedGroups={selectedGroups}
          setSelectedGroups={setSelectedGroups}
          setParentGroupId={setParentGroupId}
          ParentGroupId={ParentGroupId}
        />
      </div>

      <div className="portal-v2-form__footer">
        <button type="button" className="portal-v2-form__btn-cancel" onClick={resetForm}>
          Cancel
        </button>
        {processing ? (
          <button type="button" className="portal-v2-form__btn-save portal-v2-form__btn-save--loading" disabled>
            Saving...
          </button>
        ) : (
          <button type="button" className="portal-v2-form__btn-save" onClick={handleSave}>
            Save
          </button>
        )}
      </div>
    </div>
  );
};

export default EntityFormV2View;
